export default __webpack_public_path__ + "static/media/push43.fd67563e.gif";